import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Ng2TableModule } from 'ng2-table/ng2-table';
import { AngularLibraryBootstrapModule } from '../../angular-library-bootstrap.module';

import { AngularTableComponent } from './angular-table.component';

@NgModule({
    imports: [
        Ng2TableModule,
        CommonModule,
        FormsModule,
        AngularLibraryBootstrapModule
    ],
    declarations: [AngularTableComponent],
    exports: [Ng2TableModule, AngularTableComponent],
    providers: []
})
export class AngularTableModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/table/angular-table.module.ts